import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

export const ElecBaseloadChart = ({ dataValues = [] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <ResponsiveLine
      data={dataValues}
      enablePoints={false}
      theme={{
        axis: {
          domain: {
            line: {
              stroke: colors.grey[100],
            },
          },
          legend: {
            text: {
              fill: colors.grey[100],
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[100],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
          },
        },
        tooltip: {
          container: {
            color: colors.primary[500],
          },
        },
      }}
      colors={row => row.color} // added
      margin={{ top: 5, right: 0, bottom: 25, left: 40 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      yFormat=" >-.2f"
      curve="catmullRom"
      tooltip={(point) => {
        const shortName = dataValues.find(row => row["id"] === point.point.serieId)["pointShortName"]
        // Customize the tooltip content here
        return (
          <div style={{backgroundColor: 'white', color: 'black', padding: '5px', borderRadius: '10px'}}>
            <div>{`Point: ${shortName}`}</div>
            <div>{`Aantal: ${point.point.data.yFormatted}%`}</div>
            <div>{`Datum: ${point.point.data.xFormatted}`}</div>
          </div>
        );
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 0,
        tickPadding: 10,
        tickRotation: 40,
        legend: "", 
        legendOffset: 36,
        legendPosition: "middle",
        tickValues: [] 
      }}
      axisLeft={{
        orient: "left",
        tickValues: 5, 
        tickSize: 3,
        tickPadding: 5,
        tickRotation: 0,
        legend: "", 
        legendOffset: -40,
        legendPosition: "middle",
        format: (value) => {
            return  `${value}%`;
        },
      }}
      enableGridX={false}
      enableGridY={false}
      pointSize={8}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      useMesh={true}
      legends={undefined}
    />
  );
};